/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link, PageNotification, Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-home';

const styles: Record<string, Interpolation<Theme>> = {
  wrapper: () => css`
    margin-top: var(--cds-spacing-400);
  `,
  paragraph: () => css`
    margin-top: var(--cds-spacing-100);
  `,
};

// See https://coursera.atlassian.net/browse/EMPLOYER-14221 for details
const InternalProgramCreationWarningBanner = () => {
  return (
    <PageNotification
      severity="warning"
      title={_t('ATTENTION COURSERIANS: Please DO NOT create customer demo learning programs under this ORG.')}
      css={styles.wrapper}
    >
      <>
        <Typography2 component="p" variant="bodyPrimary">
          <FormattedMessage
            message={_t(
              'This learning portal is for internal use and should not be used for any customer demo learning program. We have a dedicated learning portal for demos that you can visit {orgLink} (org slug: futureco). Learning programs that the People Development team has not approved will be deleted from this portal.'
            )}
            orgLink={
              <Link href="/o/futureco/admin/home" variant="quiet" typographyVariant="bodyPrimary">
                {_t('here')}
              </Link>
            }
          />
        </Typography2>
        <Typography2 component="p" variant="bodyPrimary" css={styles.paragraph}>
          <FormattedMessage
            message={_t(
              '{approvedLearningPrograms} Coursera Alumni Learning Program, SkillUp and Coursera Learning Program (DO NOT USE FOR LEARNING)'
            )}
            approvedLearningPrograms={<strong>{_t('Approved learning programs are:')}</strong>}
          />
        </Typography2>
        <Typography2 component="p" css={styles.paragraph}>
          {_t('If you have any questions, please email peopledevelopmentteam@coursera.org')}
        </Typography2>
      </>
    </PageNotification>
  );
};

export default InternalProgramCreationWarningBanner;
